import {FormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {ALL_PIPES} from './pipes/pipes';
import * as de from './translations/de';
import {CommonModule} from '@angular/common';
import {APP_COMPONENTS} from './components/all.components';
import {CoreModule, TranslationService} from '@lv1871/core';
import {ALL_DIRECTIVES} from './directives/directives';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DocumentViewerModule} from '../lib-core/components/documentViewer/documentViewer.module';
import {ALL_SERVICES} from './services/services';
import {DispatchService} from './services/dispatch.service';
import {MenuStateService} from './services/menu-state.service';
import {DialogListenerService} from './services/dialog-listener.service';
import {MenuWorkflowService} from './services/menu-workflow.service';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginator} from './models/customPaginator';
import {OverlayModule} from '@angular/cdk/overlay';
import {
  FondsportfolioVermittlerspezifischModule
} from '../lives-web-components/src/app/fondsportfolio-vermittlerspezifisch/fondsportfolio-vermittlerspezifisch.module';

@NgModule({
  declarations: [
    ...APP_COMPONENTS, ...ALL_PIPES, ...ALL_DIRECTIVES,
  ],
  exports: [
    ...APP_COMPONENTS, ...ALL_PIPES, ...ALL_DIRECTIVES
  ],
  imports: [CoreModule, FormsModule, CommonModule, DocumentViewerModule, OverlayModule, FondsportfolioVermittlerspezifischModule],
  providers: [
    {provide: MAT_DIALOG_DATA, useValue: null},
    {provide: MatDialogRef, useValue: {}},
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginator
    },
    ...ALL_SERVICES,
    provideHttpClient(withInterceptorsFromDi()),
  ]
})

export class DialogToolboxModule {
  constructor(private _translationService: TranslationService,
              private _dialogListenerService: DialogListenerService,
              private _menuWorkflowService: MenuWorkflowService,
              private _dispatchService: DispatchService, private _menuStateService: MenuStateService) {
    this._dialogListenerService.init();
    this._translationService.addTranslations('de', de.translations);
  }
}
